import { I18n } from 'src/translations/i18n';
import { toastr } from 'react-redux-toastr';
import toastrError from 'src/helpers/toastr/toastrError';
import { wtsApi } from 'src/api';
import VirtualEventTable from './tools/VirtualEventsTable';
export var TimeTableActions;
(function (TimeTableActions) {
    TimeTableActions["GET_TIME_TABLE_REQUEST"] = "GET_TIME_TABLE_REQUEST";
    TimeTableActions["GET_TIME_TABLE_SUCCESS"] = "GET_TIME_TABLE_SUCCESS";
    TimeTableActions["GET_TIME_TABLE_FAIL"] = "GET_TIME_TABLE_FAIL";
})(TimeTableActions || (TimeTableActions = {}));
function getTimeTableRequest() {
    return { type: TimeTableActions.GET_TIME_TABLE_REQUEST };
}
function getTimeTableSuccess(payload) {
    return { type: TimeTableActions.GET_TIME_TABLE_SUCCESS, payload };
}
function getTimeTableFail() {
    return { type: TimeTableActions.GET_TIME_TABLE_FAIL };
}
export function getTimeTable(params) {
    return (dispatch) => {
        dispatch(getTimeTableRequest());
        const withSlipTimes = params.CalculateSlipTimes;
        const requests = [
            withSlipTimes ? wtsApi.v2.virtualEventSearchCreate({ ...params, CalculateSlipTimes: true }) : Promise.resolve(null),
            wtsApi.v2.virtualEventSearchCreate({ ...params, CalculateSlipTimes: false })
        ];
        return Promise.all(requests)
            .then(([data, dataWithoutSlipTimes]) => {
            const inputData = {
                dataWithSlipTimes: data?.data.Data,
                dataWithoutSlipTimes: dataWithoutSlipTimes?.data.Data
            };
            const parsedData = new VirtualEventTable(params, inputData);
            dispatch(getTimeTableSuccess(parsedData));
            if (!inputData.dataWithoutSlipTimes?.Persons?.length) {
                toastr.warning(I18n.t('NoDataAvailable'), '');
            }
        })
            .catch((error) => {
            console.error(error);
            dispatch(getTimeTableFail());
            toastrError(error);
        });
    };
}
